<!-- PopupComponent.vue -->
<template>
  <div ref="popup" class="popup scrollpadding overlay" v-if="isVisible">
    <div class="control_container control_container-mobile" style="flex:0 0 auto;">
      <span @click="previousPopup" class="button prevstep outline"><img style="transform: scaleX(-1);"
                                                                        src="@/assets/img/arrow-right.svg"><span>{{ $t("general.backwards") }}</span></span>
      <span @click="nextPopup" href="#" class="button nextstep"><span>{{ $t("general.forward") }}</span>
            <img src="@/assets/img/arrow-right.svg">
          </span>
    </div>
    <span class="popup_closepopup closeoverlay" :class="[content.direction]" @click="closePopup">
        <svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
      </span>
    <div class="popup_wrapper" :class="{'hasQuiz': content.quiz}">

      <div class="popup_content popup_content_left">
        <div class="popup_content_left__wrapper">

          <h2>{{ content.title }} - {{ content.subtitle }}</h2>
          <div>
            <p v-for="(paragraph, index) in content.paragraphs.slice(0, 1)" :key="index">
              {{ paragraph }}
            </p>
            <picture v-if="content.picture.tablet">
              <source media="(max-width: 799px)" :srcset="require('@/assets/img/detailpopup/'+content.picture.mobile)"/>
              <source media="(min-width: 800px)" :srcset="require('@/assets/img/detailpopup/'+content.picture.tablet)"/>
              <img :src="require('@/assets/img/detailpopup/'+content.picture.tablet)"
                   alt="Bild zum Thema {{content.title}}"/>
            </picture>
            <p v-for="(paragraph, index) in content.paragraphs.slice(1)" :key="index + 1">
              {{ paragraph }}
            </p>
          </div>
          <template v-if="content.paragraphs2">
            <p v-for="(paragraph, index) in content.paragraphs2" :key="index">{{ paragraph }}</p>
          </template>
          <template v-else>
            <p v-for="(paragraph, index) in content.paragraphs" :key="index">{{ paragraph }}</p>
          </template>


          <a :href="content.buttonLink" target="_blank" class="button"><span>{{ content.buttonText }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="45.255" height="45.255" viewBox="0 0 45.255 45.255">
              <g id="arrow-right" transform="translate(0 22.627) rotate(-45)">
                <path id="Pfad_26" data-name="Pfad 26" d="M0,0H32V32H0Z" fill="none"/>
                <path id="Pfad_27" data-name="Pfad 27" d="M5,12H23.667" transform="translate(1.667 4)"
                      fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"/>
                <path id="Pfad_28" data-name="Pfad 28" d="M13,20l8-8" transform="translate(4.333 4)"
                      fill="none"
                      stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Pfad_29" data-name="Pfad 29" d="M13,6l8,8" transform="translate(4.333 2)"
                      fill="none"
                      stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </g>
            </svg>
          </a></div>
      </div>
      <div class="popup_content popup_content_right">
        <div class="control_container" style="flex:0 0 auto;">
          <span @click="previousPopup" class="button prevstep outline"><img style="transform: scaleX(-1);"
                                                                            src="@/assets/img/arrow-right.svg"><span>{{ $t("general.backwards") }}</span>
          </span>
          <span @click="nextPopup" href="#" class="button nextstep"><span>{{ $t("general.forward") }}</span>
            <img src="@/assets/img/arrow-right.svg">
          </span>
        </div>
        <div v-if="content.funfact" class="popup_content__quickinfowrapper">
          <div ref="herowrapper" class="herowrapper">
            <img src="@/assets/img/female.png"/>
            <img src="@/assets/img/male.png"/>
          </div>
          <div class="popup_content__quickinfo">
            <div class="popup_content__quickinfotext">
              <p>
                <strong class="funfact-intro">
                  {{ content.addContentIntro }}
                </strong>

                {{ content.funfact }}
              </p>
            </div>
          </div>
        </div>
        <QuizComponent
            v-if="content.quiz"
            :quizData="content.quiz"
            :quizIntroData="content.addContentIntro"
        >
        </QuizComponent>
      </div>
    </div>
  </div>
</template>

<script>
import {gsap} from "gsap";
import QuizComponent from "@/components/ThreeJs/QuizComponent/QuizComponent.vue";

export default {
  components: {QuizComponent},
  props: {
    content: {
      type: Object,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    animationType: {
      type: String,
      default: 'default' // Mögliche Werte: 'default', 'previous', 'next'
    }
  },
  data() {
    return {
      popup: null,
    }
  },
  watch: {
    // Beobachte die `isVisible` Eigenschaft
    isVisible(newValue) {
      // Überprüfe, ob `newValue` true ist
      if (newValue) {
        this.popupBecameVisible();
      }
    }
  },
  mounted() {
  },
  methods: {
    popupBecameVisible() {

      this.$nextTick(() => {
        // Standardanimation als Fallback
        let animation = () => {

          const herowrapper = this.$refs.herowrapper;

          // GSAP Animation mit Stagger-Effekt
          this.$refs.popup.style.display = 'block';
          gsap.to(this.$refs.popup, {
            opacity: 1,
            onComplete: () => {
              this.$emit('animationFinished', this.content.direction);
            }
          });
          gsap.fromTo('.popup_content.popup_content_left', {
            y: "10%",
            autoAlpha: 0

          }, {
            y: "0%",
            autoAlpha: 1,
            delay: 0.25
          })
          gsap.fromTo('.popup_content_right', {
            x: "10%",
            autoAlpha: 0,
          }, {
            x: "0%",
            autoAlpha: 1,
            delay: 0.75
          })
          if (herowrapper) {
            const images = herowrapper.querySelectorAll('img');
            gsap.from(images, {
              autoAlpha: 0,
              y: -50, // Optional: bewegt die Bilder 50px von unten nach oben
              stagger: 0.2, // Zeitverzögerung zwischen den Animationen der einzelnen Bilder
              duration: 1, // Dauer der Animation für jedes Bild
              delay: 2
            });
          }

        };

        if (this.animationType === 'previous') {
          // Definiere eine spezielle Animation für 'previous'
          animation = () => {
            this.$refs.popup.style.display = 'block';
            gsap.fromTo(this.$refs.popup, {
              opacity: 0,
              display: "none",
              x: "10vw"
            }, {
              opacity: 1,
              display: "block",
              x: 0,
              onComplete: () => {
                this.$emit('animationFinished', this.content.direction);
              }
            })
            gsap.fromTo('.popup_content.popup_content_left', {
              y: "10%",
              autoAlpha: 0

            }, {
              y: "0%",
              autoAlpha: 1,
              delay: 0.25
            })
            gsap.fromTo('.popup_content_right', {
              x: "10%",
              autoAlpha: 0
            }, {
              x: "0%",
              autoAlpha: 1,
              delay: 0.75
            })
          };
        } else if (this.animationType === 'next') {
          // Definiere eine spezielle Animation für 'next'
          animation = () => {
            this.$refs.popup.style.display = 'block';
            gsap.fromTo(this.$refs.popup, {
              opacity: 0,
              display: "none",
              x: "-10vw"
            }, {
              opacity: 1,
              display: "block",
              x: 0,
              onComplete: () => {
                this.$emit('animationFinished', this.content.direction);
              }
            })
            gsap.fromTo('.popup_content.popup_content_left', {
              y: "10%",
              autoAlpha: 0

            }, {
              y: "0%",
              autoAlpha: 1,
              delay: 0.25
            })
            gsap.fromTo('.popup_content_right', {
              x: "10%",
              autoAlpha: 0
            }, {
              x: "0%",
              autoAlpha: 1,
              delay: 0.75
            })
          };
        }

        // Führe die ausgewählte Animation aus
        animation();
        // Entscheide basierend auf dem animationType-Prop, welche Animation ausgeführt werden soll

      });
    },
    closePopup() {
      gsap.to(this.$refs.popup, {
        opacity: 0,
        onComplete: () => {
          this.$emit('close', this.content.direction);
        }
      });
    },
    previousPopup() {
      this.$emit('previousPopup');
    },
    nextPopup() {
      this.$emit('nextPopup');
    }
  }
};
</script>


<style lang="scss" scoped>
.popup_content_left__wrapper {
  picture {
    float:left;
    width:60%;
    max-width:600px;
    margin:8px 15px 0 0 !important;
  }
}

h2 {
  line-height: 1.2em;
}
.funfact-intro{
  display:block; font-weight:700;
}
</style>
